import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Trip, TripDisplay, transformTrip } from "@/lib/trips";

export const useTrips = () => {
  return useQuery({
    queryKey: ["trips"],
    queryFn: async (): Promise<TripDisplay[]> => {
      // Check if Supabase is configured
      if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
        console.warn('Supabase not configured. Returning empty trips array.');
        return [];
      }

      try {
        const { data, error } = await supabase
          .from("trips")
          .select("*")
          .order("created_at", { ascending: true });

        if (error) {
          console.error('Error fetching trips:', error);
          throw error;
        }

        return (data as Trip[]).map(transformTrip);
      } catch (error) {
        console.error('Error in useTrips:', error);
        return [];
      }
    },
    retry: false, // Don't retry if Supabase is not configured
  });
};
